import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { winningAmountStore } from '../../store/winningAmountStore';
import { ROUND_WIN_TYPE_COLOR, ROUND_WIN_TYPE } from '../../enums/betTypesEnum';

export const WinBetType = observer(() => {
  const { winType } = winningAmountStore;
  const t = useTranslation();

  if (winType === null) {
    return null;
  }
  return (
    <div className='game-result-btns-wrp'>
      <button className={`game-result-btn ${ROUND_WIN_TYPE_COLOR[winType]}`}>
        <span>{t(ROUND_WIN_TYPE[winType])}</span>
      </button>
    </div>
  );
});
